import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportType } from '@app/domain/model/report-type';

import { Species } from './species.model';

@Injectable({
  providedIn: 'root'
})
export class SpeciesService {

  private readonly speciesUrl = 'species/';

  constructor(private readonly http: HttpClient) {
  }

  getSpecies(q: string, reportType: string) {
    const params = {
      q: q,
      reportType: ReportType[reportType]
    };

    return this.http.get<Species>(this.speciesUrl, { params: params });
  }

}
